// ** Third Party Components
import { ChevronRight } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledTooltip } from 'reactstrap'

// ** Styles
import './new-system.scss'

const newSystemBase = () => (process.env.REACT_APP_NEW_SYSTEM_URL || '').replace(/\/$/, '')

export const hasNewSystem = () => !!process.env.REACT_APP_NEW_SYSTEM_URL

// ** Hand the current session to the new system: <new>/switch#t=<access>&r=<refresh>&from=<pathname>
export const openNewSystem = () => {
  const base = newSystemBase()
  const t = localStorage.getItem('accessToken')
  const raw = localStorage.getItem('refreshToken')
  let r = raw
  try {
    r = JSON.parse(raw)
  } catch {
    // stored raw by jwtService.login
  }
  if (t && r) {
    const fragment = new URLSearchParams({ t, r, from: window.location.pathname })
    // A storage transload order: its storage number lives only in sessionStorage
    const filed = sessionStorage.getItem('storageNumber')
    if (filed && /^\/apps\/transload-order\/view\/[^/]+\/?$/i.test(window.location.pathname)) {
      try {
        const storage = JSON.parse(filed)
        if (storage) fragment.set('storage', storage)
      } catch {
        // not a number the list filed
      }
    }
    window.location.assign(`${base}/switch#${fragment.toString()}`)
  } else {
    window.location.assign(`${base}/login`)
  }
}

// ** Four-point sparkle centred on (x, y)
const sparklePath = (x, y, s) => `M${x} ${y - s}Q${x} ${y} ${x + s} ${y}Q${x} ${y} ${x} ${y + s}Q${x} ${y} ${x - s} ${y}Q${x} ${y} ${x} ${y - s}Z`

const Sparkle = ({ className }) => (
  <svg className={className} viewBox='0 0 10 10' aria-hidden='true'>
    <path d={sparklePath(5, 5, 5)} />
  </svg>
)

// ** Line-art container ship; the one red container is the new system
const Ship = ({ className }) => (
  <svg className={className} viewBox='0 0 72 44' fill='none' aria-hidden='true'>
    <path className='ns-ship__sea' d='M2 38c4-2.4 8-2.4 12 0s8 2.4 12 0 8-2.4 12 0 8-2.4 12 0 8-2.4 12 0 8-2.4 8-1.2' />
    <g className='ns-ship__boat'>
      <path d='M8 27h56l-6 8H14z' />
      <rect x='15' y='19' width='10' height='8' rx='1' />
      <rect x='25' y='19' width='10' height='8' rx='1' />
      <rect className='ns-ship__new' x='35' y='19' width='10' height='8' rx='1' />
      <rect x='25' y='11' width='10' height='8' rx='1' />
      <path d='M50 27V16h8v11M53 16v-4' />
    </g>
    <g className='ns-ship__sparkles'>
      <path className='ns-ship__sparkle' d={sparklePath(44, 10.5, 4.8)} />
      <path className='ns-ship__sparkle' d={sparklePath(36.5, 2.5, 2.8)} />
      <path className='ns-ship__sparkle' d={sparklePath(65, 8, 3.4)} />
    </g>
  </svg>
)

// ** Login screen: no session to hand over yet, so this goes straight to the new system's sign-in
export const NewSystemBanner = () => {
  if (!hasNewSystem()) return null

  return (
    <a className='ns-banner' href={`${newSystemBase()}/login`}>
      <Ship className='ns-ship' />
      <span className='ns-banner__body'>
        <span className='ns-banner__eyebrow'>New</span>
        <span className='ns-banner__title'>Try the new ShipSmpl</span>
        <span className='ns-banner__text'>Same account, redesigned experience.</span>
      </span>
      <span className='ns-banner__chevron'>
        <ChevronRight size={16} />
      </span>
    </a>
  )
}

// ** Navbar: carries the live session and the current page across
export const NewSystemNavButton = () => {
  if (!hasNewSystem()) return null

  return (
    <>
      <button type='button' id='newSystemLink' className='ns-pill' onClick={openNewSystem}>
        <Sparkle className='ns-pill__sparkle' />
        <Ship className='ns-ship ns-ship--small' />
        <span className='ns-pill__label'>New system</span>
        <ChevronRight size={14} className='ns-pill__chevron' />
      </button>
      <UncontrolledTooltip placement='bottom' target='newSystemLink'>
        Open this page in the new system
      </UncontrolledTooltip>
    </>
  )
}
